module.exports = __webpack_public_path__ + "img/satisfaction.0a7dc259.svg";